// extracted by mini-css-extract-plugin
module.exports = {"inBodyAd":"styles_inBodyAd__23KGn"};